import { Permission, User } from '../models/User';
import { createCtx } from './createCtx';

export type Auth = {
    isLoggedIn: boolean;
    currentUser: User | undefined;
};

export type AuthContextType = {
    auth: Auth;
    setAuth: (auth: Auth) => void;
    checkSession: () => void;
    autoLogin: (user: User) => void;
    logout: () => void;
    hasPermission: (permission: Permission) => boolean;
};

export const [useAuth, CtxProvider] = createCtx<AuthContextType>();
